import { LinearProgress } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { RootState } from "store";
import { useAppSelector } from "store/hooks";

const useStyles = makeStyles(() =>
  createStyles({
    regularProgress: {
      width: "100%",
    },
    invisibleProgress: {
      width: "100%",
      visibility: "hidden",
    },
  })
);

const Loader: React.FC = (): React.ReactElement => {
  const classes = useStyles();
  const { pending, fulfilled, rejected } = useAppSelector(
    (state: RootState) => {
      return state.common.asyncCounter;
    }
  );

  return (
    <div
      className={`${
        pending !== fulfilled + rejected
          ? classes.regularProgress
          : classes.invisibleProgress
      }`}
    >
      <LinearProgress />
    </div>
  );
};

export default Loader;
